import { useEffect, useState, useMemo  } from "react";
import {
  Container,
  ContainerView,
  ContainerRow,
} from "../../../components/Container";
import { Form } from "antd";
import { useApp } from "../../../contexts";

import {
  errorView,
  formatCurrency,
  getWalletOptionDetail,
  postClaimConfirm,
  postClaimSendCode,
} from "../../../services/app";
import produce from "immer";
import { useNavigate, useSearchParams } from "react-router-dom";
import { TitleWithBack } from "../../../components/Layout";
import {
  WithdrawFormContainer,
} from "../styles";
import {
  Body,
  AuthFormInputSpan2,
  Footer,
  FormButtonCancel3,
  FormButton2
} from "./styles";

import FormInput from "../../../components/FormCustom2/Input";
import styled from "styled-components";
import { ModalPasswordRequired } from "../../../components/ModalPasswordRequired";
import { AIAIcon } from "../../../components/Icons/AIAIcon";
import { error, success } from "../../../Notification";
import { getCoinCodeImage } from "../../../utils/helper";
const InputOtpWraper = styled.div`
  position: relative;
  flex: 1;
  & input {
    padding-right: 110px;
  }
`;
export default function WithDrawSOT(props) {
  const {
    T,
    isLoading,
    setLoading,
  } = useApp();
  const [otp, setOtp] = useState("");
  const [sentOtp, setSentOtp] = useState(0);
  const [claimId, setClaimId] = useState(null);

  const navigate = useNavigate();
  let { code, type } = props || {};
  const [searchParams] = useSearchParams();
  if (!code && searchParams.get("code")) {
    code = searchParams.get("code");
  }
  const [isDisabled, setIsDisabled] = useState(false);
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [wallet, setWallet] = useState({});
  const [errors, setErrors] = useState([]);
  useEffect(() => {
    const timer = setInterval(() => {
      setSentOtp((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        return prevState;
      });
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  useEffect(() => {
    if (code) {
      loadData();
    }
  }, [code]);
  
  const onBack = () => {
    navigate(-1);
  };
  
  useEffect(() => {
    setIsDisabled(isLoading || !otp)
  }, [isLoading, otp])

  const loadData = async () => {
    setLoading(true);
    let result = await getWalletOptionDetail({code});
    if (result.status === 200) {
      const item = result?.data?.data || {};
      setWallet(item);
    }
    setLoading(false);
  };

  const currentWallet = useMemo(() => {
    return wallet
  }, [wallet])

  const onTransactionHistory = () => {
    let codeOrigin = code;
    if (currentWallet.currencyCode) {
      codeOrigin = currentWallet.currencyCode;
    }
    navigate(
      `/wallet?type=option`
    );
  };
  const onSentOtp = async () => {
    setLoading(true);
    const result = await postClaimSendCode({
      currencyCode: currentWallet.currencyCode,
      amount: currentWallet.claimableBalance,
    });
    if (result.status === 200) {
      setSentOtp(180);
      setClaimId(result?.data?.data?.claimRequestId)
    } else {
      setErrors(result?.data?.error?.validates || []);
    }
    setLoading(false);
  };
  const amountError = useMemo(() => {
    if (errors?.length > 0) {
      const error = errors.filter((item) => item.key === "amount");
      if (error.length > 0 ) {
        return error?.[0]?.value
      }
    } 
    return ''
  }, [errors])
  const onSubmit = async () => {
    setLoading(true);
    const result = await postClaimConfirm({
      currencyCode: currentWallet.currencyCode,
      claimRequestId: claimId,
      verificationCode: otp,
      amount: currentWallet.claimableBalance,
    });
    if (result.status === 200) {
      success(T("Your claim request has been created and under processing."))
      onTransactionHistory()
    } else {
      setErrors(result?.data?.error?.validates || []);
      if (!(result?.data?.error?.validates || []).length) {
        error(T('Failed to create your request. Please try again later.'))
      }
    }
    setLoading(false);
  };
  const iconCurrency = useMemo(() => {
    return `/assets/images/otc/crypto/${getCoinCodeImage(
      currentWallet.currencyCode
    )?.toLowerCase()}.svg`
  }, [currentWallet])
  return currentWallet ? (
    <Container>
      <ContainerView>
        <TitleWithBack title={T("Claim request")} onClick={onBack} />
        <WithdrawFormContainer>
          <Body className="form">
            <div className="lg:px-3 flex flex-col gap-2">
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">{T("Recipient’s Address")}</div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <AIAIcon /> <span className="">{T('AI Avatar Web3 Wallet Address')}</span>
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">{T("Token")}</div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <img
                    alt=""
                    style={{ width: 28, height: 28 }}
                    src={iconCurrency}
                  /> 
                  <span className="">{currentWallet?.currencyCode}</span>
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">{T("Payable Amount (Only fully claim supported)")}</div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex flex-wrap justify-start items-center gap-2">
                  <span className="">{formatCurrency(currentWallet?.claimableBalance)}{" "}{currentWallet?.currencyCode}</span>
                  {amountError ? <div className="text-red-500 font-normal text-sm italic w-full -mt-2">{T(amountError)}</div> : <></>}

                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base ">{T("Gas Fee")}</div>
                <div className="border-b border-solid border-[#CCCCCC] text-black font-normal text-base font-inter pb-[10px] flex justify-start items-center gap-2">
                  <span className="">{T('Free')}</span>
                </div>
              </div>
              <div className="row-item-sot">
                <div className="text-[#818181] font-semibold font-base flex justify-start items-center gap-[2px]">{T("Enter Email Verification Code")}</div>
                <div className="text-black font-normal text-base">
                <InputOtpWraper>
                  <Form.Item
                    {...errorView(errors, "verificationCode")}
                    name={"otp"}
                    style={{
                      width: "100%",
                      marginTop: 5,
                    }}
                  >
                    <FormInput
                      value={otp}
                      className="input-sot2 no-border"
                      onChange={(event) => {
                        setOtp(event.target.value);
                        setErrors(
                          produce((draft) => {
                            draft.splice(
                              draft.findIndex(
                                (item) => item.key === "verificationCode"
                              ),
                              1
                            );
                          })
                        );
                      }}
                      readOnly={sentOtp <= 0}
                      placeholder={
                        sentOtp <= 0
                          ? T("Click “Send Code”")
                          : T("Enter Email Verification Code")
                      }
                    />
                  </Form.Item>
                  <AuthFormInputSpan2
                    className={"send-code text-aia-red absolute"}
                    style={{ top: 14, right: 12 }}
                    onClick={() => {
                      if (sentOtp <= 0) {
                        onSentOtp().then();
                      }
                    }}
                  >
                    {sentOtp > 0 ? `${sentOtp}s` : T("Send Code")}
                  </AuthFormInputSpan2>
                </InputOtpWraper>
                </div>
              </div>
            </div>
            <Footer style={{ marginTop: 0, marginLeft: 12, marginRight: 12 }}>
              <ContainerRow>
                <FormButtonCancel3
                  style={{ marginRight: 8 }}
                  onClick={onBack} 
                >
                  {T("Cancel")}
                </FormButtonCancel3>
                <FormButton2
                  disabled={isDisabled}
                  style={{ marginLeft: 8 }}
                  onClick={() => onSubmit()}
                >
                  {T("Claim")}
                </FormButton2>
              </ContainerRow>
            </Footer>
          </Body>
        </WithdrawFormContainer>
      </ContainerView>
    </Container>
  ) : null;
}
